import DivContainerBody from "../../../../../components/DivContainerBody";
import EmployeeCardGrid from "../../../../Contractor/Employee/SubComponents/EmployeeCardGrid";
import DocumentStatusThree from "../../../../../components/DocumentStatusThree";
import {TABLES} from "../../../../../Apis/Tables";
import {
    CreateSupplierDocValue,
    DownloadProviderImage,
    SetSupplierDocValue
} from "../../../../../reduxToolkit/Providers/providersApi";
import {USER_TYPE_DOCUMENT} from "../../../../../enums/userTypeEnum";
import DeleteModal from "../../../../Modals/DeleteModal";
import UnlinkDeviceChangeModal from "../../../Modal/UnlinkDeviceChangeModal";
import React from "react";
import {SupplierFlowDocumentDetailApp} from "../../Funtionality/SupplierDetailsFlows/SupplierFlowDocumentDetailApp";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SupplierFlowDocumentDetail= (props) => {
    const {  deleteEmployeeShow, setDeleteEmployeeShow, unlinkShow,  setUnlinkShow, showBtnDeleteDoc, disabled } = props;

    const {
        t,
        deleteDocShow,
        setDeleteDocShow,
        selectDocumentsForDelete,
        selectEmployeeForDelete,
        setSelectDocumentsForDelete,
        isAllChecked,
        setIsAllChecked,
        elementDetails,
        deletedFlag,
        setDeletedFlag,
        deleteSelectedDocuments,
        deleteSelectedElement
    } = SupplierFlowDocumentDetailApp(props);

    return (
        <>
            <DivContainerBody>
                <div className='row mt-5rem'>
                    <EmployeeCardGrid elementDetails={elementDetails}/>
                    <div className='col-8 mb-2'>
                        <div className='w-100 border-card h-100'>
                            <DocumentStatusThree
                                disabled={disabled}
                                dataTable={elementDetails?.documents}
                                userType={TABLES.EMPLOYEES}
                                setDocValue={SetSupplierDocValue}
                                createDocValue={CreateSupplierDocValue}
                                downloadImg={DownloadProviderImage}
                                optionDownload={USER_TYPE_DOCUMENT.SUPPLIER_DOCUMENT}
                                isAllChecked={isAllChecked}
                                setIsAllChecked={setIsAllChecked}
                                selectDocumentsForDelete={selectDocumentsForDelete}
                                setSelectDocumentsForDelete={setSelectDocumentsForDelete}
                                showBtnDelete={showBtnDeleteDoc}
                                deleteShowModal={deleteDocShow}
                                setDeleteShowModal={setDeleteDocShow}
                                handleDelete={deleteSelectedDocuments}
                            />

                        </div>
                    </div>
                </div>
            </DivContainerBody>

            <DeleteModal
                title_modal={t('delete')}
                show={deleteEmployeeShow}
                onHide={() => setDeleteEmployeeShow(false)}
                element_modal={t('employees')}
                data={[selectEmployeeForDelete]}
                onClickFn={() => deleteSelectedElement(selectEmployeeForDelete)}
            />

            <UnlinkDeviceChangeModal
                show={unlinkShow}
                onHide={() => setUnlinkShow(false)}
                onConfirm={() => setDeletedFlag(deletedFlag + 1)}
                userId={elementDetails?.user?.id}
            />
        </>
    );
};
export default SupplierFlowDocumentDetail
